var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('supplier-form',{attrs:{"loading":_vm.loading,"supplierData":_vm.supplier,"formErrors":_vm.formErrors},on:{"supplierSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }